export default {
    listagem: {
        titulo_pagina: 'Lista de Integraciones',
        novo: 'Crear Nueva Integración',
        campos_tabela: 'Campos de tabla',
        table: {
            empty: 'No se encontró ninguna integración',
            nome: 'Nombre',
            protocolo: 'Protocolo',
            mnemonico: 'Mnemotécnico',
            fabricante: 'Fabricante',
            tipo_integracao: 'Tipo de Integración',
            complemento: 'Complementar',
            tipo_complemento: 'Tipo do complemento',
            forcar_complemento: 'Complemento de fuerza',
            tamanho_recipiente: 'Tamaño del mango del contenedor',
            file_format: 'Formato de archivo',
            host_homologacao: 'Host de homologación',
            host_producao: 'Host de producción',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Integración',
            editar: 'Editar Integración'
        },
        fieldsets: {
            informacoes: 'Información',
            comunicacao: 'Comunicación',
            hosts: 'Hosts',
            camada: 'Capa Anticorrupción'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre de Integración'
            },
            mnemonico: {
                label: 'Mnemotécnico',
                description: 'Acrónimo de Integración'
            },
            tipo_integracao: {
                label: 'Tipo de Integración',
                description: 'Tipo de Integración Utilizada'
            },
            fabricante: {
                label: 'Fabricante',
                description: 'Fabricante de Integración'
            },
            protocolo: {
                label: 'Protocolo',
                description: 'Protocolo de Comunicación de Integración'
            },
            formato_arquivo: {
                label: 'Formato de Archivo',
                description: 'Formato de archivo utilizado en la Integración'
            },
            pubsub_topic_result_out: {
                label: 'Resultado PubSub Tema',
                description: 'Resultado de Salida Tema de PubSub'
            },
            pubsub_topic_order_out: {
                label: 'Orden Tema de PubSub',
                description: 'Tema de PubSub de Orden de Salida'
            },
            pubsub_topic_label_out: {
                label: 'Tema PubSub de la Etiqueta',
                description: 'Etiqueta de Salida Tema de PubSub'
            },
            host_homologacao: {
                label: 'Host de Homologación',
                description: 'Host utilizado para ratificar la Integración'
            },
            host_producao: {
                label: 'Host de Produccion',
                description: 'Host donde apuntará la Integración'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa que podrá realizar la Integración'
            },
            equipamento: {
                label: 'Equipo',
                description: 'Equipos autorizados para la Integración'
            },
            status: {
                label: 'Estado',
                description: 'Estado de integración activa o inactiva'
            },
            sport: {
                label: 'Integración Deportiva',
                description: 'Integración deportiva que trabaja con deportistas'
            },
            bloquear_dexpara: {
                label: 'Bloquear Enviar',
                description: 'Bloquea el envío en caso de error deXpara'
            },
            bypass_material_complement: {
                label: 'Bypass Material Complementario',
                description: 'Permite el procesamiento de la integración sin la obligatoriedad del mapeo del material complementario'
            },
            botao_salvar : 'Guardar Integración'
        },
        create: {
            success: '¡Integración creada con éxito!',
            error: '¡Error al crear la integración!'
        },
        update: {
            success: '¡Integración editada con éxito!',
            error: '¡Error al editar la integración!'
        },
        errors: {
            possible_specimens_linked: 'No es posible cambiar el tipo de la integración porque existen Materiales Posibles registrados vinculados a esta integración'
        }
    }
}
